import { identity } from "@mdotm/utils/functions";
import { tryOrFallback } from "./errors";

export function tryJsonParse<T>(
	serialized: string,
	fallback: T,
	/** Can throw to indicate that the parsed JSON found in the storage area is invalid */
	parser: (val: object | null) => T = identity<any>,
): T {
	if (!serialized) {
		return fallback;
	}
	return tryOrFallback(() => {
		const deserialized = JSON.parse(serialized) as T | null | undefined;
		if (deserialized === undefined) {
			return fallback;
		}
		return tryOrFallback(() => parser(deserialized), fallback);
	}, fallback);
}
